export default "__VITE_ASSET__BfBABC_k__"